import { formatValueForDisplay, toTitleCase } from "../../utils/viewUtils";

interface DetailLineProps {
  label: string;
  value: any;
}

export const DetailLine: React.FC<DetailLineProps> = ({ label, value }) => {
  let formattedValue: string | null = null;

  // special‑case “bank_balance” for our demo - we'll need to add more cases like this for other situations
  if (label === "bank_balance" && value !== null && value !== undefined) {
    const num = Number(value);
    if (!Number.isNaN(num)) {
      formattedValue = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        maximumFractionDigits: 2,
      }).format(num);
    }
  }

  if (formattedValue === null) {
    formattedValue = formatValueForDisplay(value);
  }
  if (formattedValue === null) return null;

  return (
    <div className="flex justify-between mb-1">
      <span className="text-sm text-text-secondary dark:text-text-secondary-dark truncate max-w-[40%]">
        {toTitleCase(label)}
      </span>
      <span className="text-sm text-text-secondary dark:text-text-primary-dark truncate max-w-[55%]">
        {formattedValue}
      </span>
    </div>
  );
};

interface ProofDetailsProps {
  title: string;
  data: Record<string, any>;
  className?: string;
}

const ProofDetails: React.FC<ProofDetailsProps> = ({
  title,
  data,
  className = "",
}) => {
  if (Object.keys(data).length === 0) return null;

  return (
    <div className={`w-full   ${className}`}>
      <div className="space-y-1">
        {Object.entries(data).map(([key, value]) => {
          if (
            typeof value === "object" &&
            !Array.isArray(value) &&
            Object.keys(value).length === 0
          ) {
            return null;
          }
          return (
            <div key={key}>
              <DetailLine label={key} value={value} />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ProofDetails;
